// Texty a čítanie názvov metód dopravy/platieb — slovenské dvojča locale/cs/shippingModel.js.
import { NBSP } from '../../modules/money.js';
import D from './dispatchEta.js';

export default {
  boxTitle: 'Výdajné miesta a boxy',
  boxDesc: 'Sieť výdajných miest po celom Slovensku',
  // SK Shoptet: „GLS na výdajné miesto", „PPL na výdajné miesto" (dev/sk/checkout-2.html)
  boxRe: /z-?box|z[áa]silkovn|bal[íi]kovn|parcel\s?shop|parcelshop|v[ýy]dajn|pickup|depo|alzabox|v[ýy]dajov/i,
  addressTitle: 'Doprava na adresu',
  addressDesc: 'Doručenie priamo na vašu adresu',
  pickupTitle: 'Osobný odber na predajni Jipos',
  pickupDesc: 'Predajňa Jipos Bílina, Teplická 906',
  // „Osobný odber" (dev/sk/*.html); na SK zatiaľ nie je v ponuke
  pickupRe: /osobn[ýy]\s*odber|predajn/i,
  // SK: neověřeno ve fixtures (nadrozměrná metoda na SK v nabídce není, Fofr ano)
  oversizeRe: /nadrozmer|nadmern|atypick/i,
  oversizeNote:
    'Tovar v košíku presahuje limity pre výdajné miesta aj bežnú dopravu na adresu, ' +
    'objednávku preto vezie nadrozmerná preprava.',
  oversizeNoteProduct:
    'Produkt presahuje limity pre výdajné miesta aj bežnú dopravu na adresu, ' + 'preto ho vezie nadrozmerná preprava.',

  mapLabel: 'Zobraziť na mape',
  stockNote: 'Všetko, čo je na e-shope skladom, máme na predajni pripravené na okamžitý odber.',
  days: D.days,
  today: D.today,
  tomorrow: D.tomorrow,
  openUntil: (hour) => 'Práve otvorené, vyzdvihnúť môžete ešte dnes do ' + hour,
  closed: 'Zatvorené',
  closedOpens: (when, hour) => 'Zatvorené, otvárame ' + when + ' o ' + hour,
  hoursLabel: 'Otváracie hodiny',
  freeShipScope: 'na výdajné miesto',

  boxRowName: (carrier) => carrier + ' na výdajné miesto',
  addrRowName: (carrier) => carrier + ' na adresu',
  addrRowDesc: 'kuriér v deň doručenia zavolá',
  glsBoxDesc: (kg) => 'do ' + kg + NBSP + 'kg (limit dopravcu), výdajné miesta aj boxy',
  pplBoxDesc: (kg) => 'do ' + kg + NBSP + 'kg (limit dopravcu), Parcelshop aj Parcelbox',
  oversizeName: 'PPL – Nadrozmerné zásielky',
  oversizeDesc: 'len atypický tovar označený v košíku',
  fofrName: 'Fofr – Nadmerné balíky',
  fofrDesc: 'len na adresu',
  pickupName: 'Osobný odber',

  kg: 'kg',
  bandUpTo: 'do',
  bandOver: 'nad',
  chipLead: 'Zásielka ',
  scaleTitle: 'Hmotnosť zásielky a cena dopravy',
  scaleBox: 'Výdajné miesto',
  scaleAddr: 'Na adresu',
  scaleNoteA: (maxKg, scope) => 'Do ' + maxKg + NBSP + 'kg ' + scope + ' zadarmo pri nákupe nad ',
  scaleOverLabel: 'Preprava pre nadmerné balíky',
  footOver: (lastKg) => 'Zásielka nad ' + lastKg + NBSP + 'kg ide prepravou pre nadmerné balíky.',
  productA: 'Produkt váži ',
  productB: ', ceny nižšie platia pre pásmo ',
  productSum: 'V košíku sa hmotnosť položiek sčítava',
  productFreeA: (maxKg) => '; do ' + maxKg + NBSP + 'kg a nad ',
  productFreeB: ' je výdajné miesto zadarmo.',

  // SK Shoptet: „Dobierkou", „Prevodom", „Online platba kartou" (dev/sk/checkout-2.html)
  payCashRe: /dobierk/i,
  payBankRe: /prevod|qr|bank/i,
  payWalletRe: /hotovos|predajn|pokladn/i,
  payCardRe: /kart|online|shoptet\s*pay|apple|google|gopay|comgate/i,
};
